import {EventRemindAtProps} from "../../types/EventRemindAt";
import {MONGO_DATE_FORMAT, MONGO_TIME_FORMAT} from "../../utils/date";
import {EventStep, EventStepProps} from "../../types/EventStep";

export function processRemindAt(remind_at?: EventRemindAtProps): { remindAt?: { date?: string; time?: string }[] } {
    const date = remind_at?.date?.format(MONGO_DATE_FORMAT);
    const time = remind_at?.time?.format(MONGO_TIME_FORMAT);

    // 1. Check if at least one value is valid
    if (!date && !time) {
        // If neither is valid, return an empty object to omit the key
        return {};
    }

    // 2. Build the object conditionally
    const newRemindAt: { date?: string; time?: string } = {};

    if (date) {
        newRemindAt.date = date;
    }
    if (time) {
        newRemindAt.time = time;
    }

    // 3. Return the key with the new object in an array
    return {remindAt: [newRemindAt]};
}

export function processSteps(steps?: EventStepProps[]): { steps?: EventStep[] } {
    // 1. Omit the key if the array is null, undefined, or empty
    if (!steps || steps.length === 0) {
        return {};
    }

    // 2. Clean each object in the array to remove 'undefined'
    const cleanedSteps = steps.map(step => {
        // This is the new, clean object
        const newStep: EventStep = {
            title: step.title
        };

        // Only add 'completedOn' if it's not undefined
        if (step.completedOn !== undefined) {
            newStep.completedOn = step.completedOn;
        }

        return newStep;
    });

    return {steps: cleanedSteps};
}